import api from './api';

/**
 * Get all places with optional filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Places list with pagination
 */
export const getPlaces = async (params = {}) => {
  const response = await api.get('/admin/places', { params });
  return response.data;
};

/**
 * Get a single place by ID
 * @param {number} id - Place ID
 * @returns {Promise<Object>} Place object
 */
export const getPlaceById = async (id) => {
  const response = await api.get(`/admin/places/${id}`);
  return response.data;
};

/**
 * Create a new place
 * @param {FormData} formData - Place data as FormData
 * @returns {Promise<Object>} Created place
 */
export const createPlace = async (formData) => {
  const response = await api.post('/admin/places', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Update a place
 * @param {number} id - Place ID
 * @param {FormData} formData - Place data as FormData
 * @returns {Promise<Object>} Updated place
 */
export const updatePlace = async (id, formData) => {
  const response = await api.put(`/admin/places/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Delete a place
 * @param {number} id - Place ID
 * @returns {Promise<Object>} Deletion result
 */
export const deletePlace = async (id) => {
  const response = await api.delete(`/admin/places/${id}`);
  return response.data;
};

const placesService = {
  getPlaces,
  getPlaceById,
  createPlace,
  updatePlace,
  deletePlace
};

export default placesService;

